/* global $ */
import 'picturefill';
import 'selectize';
import './maps';
import './frontpage_slider';
import './team_slider';
import './cereal_slider';
import './contact';
import './logo_slider';
import './retailers';
import './retailers-scroll';
import './product_order';
import './smooth-scroll';
import './szechenyi_2020_banner';

$(() => {
	// eslint-disable-next-line one-var
	const $contactAgreeWrapper = $('.contact-agree-privacy-wrapper'),
		wpcf7Warp = '.wpcf7-form-control-wrap';

	$contactAgreeWrapper.css('display', 'block');
	$contactAgreeWrapper.children(wpcf7Warp).addClass('contact-agree-privacy');

	$('#contact-agree-privacy')
		.on('change', function () {
			// eslint-disable-next-line no-unused-expressions
			this.checked ? $(wpcf7Warp).addClass('accepted') : $(wpcf7Warp).removeClass('accepted');
		})
		.trigger('change');
});

// Mobile submenu menu toggle
$(() => {
	const $subMenuWrappers = $('.menu-item-has-children > a');

	// eslint-disable-next-line func-names
	$subMenuWrappers.click(function (event) {
		event.preventDefault();
		const $thisParent = $(this).parent();

		$('.menu-item-has-children').not($thisParent).removeClass('menu-item-has-children--open');
		$thisParent.toggleClass('menu-item-has-children--open');
	});
});


// Mobile main menu toggle
$(() => {
	// eslint-disable-next-line one-var
	const $hamburger = $('.yco-hamburger'),
		$menu = $('.yco-hamburger__menu');

	$hamburger.click(() => {
		if ($menu.hasClass('yco-hamburger__menu--open')) {
			$menu.removeClass('yco-hamburger__menu--open');
			$('body').removeClass('yco-hamburger-menu__open');
		} else {
			$menu.addClass('yco-hamburger__menu--open');
			$('body').addClass('yco-hamburger-menu__open');
		}
	});
});

$(() => {
  // eslint-disable-next-line func-names
	$('.menu-item').hover(function () {
		$(this).toggleClass('hovered');
	});
});



// WEBPACK FOOTER //
// ./assets/scripts/main.js